@if (!editing) {
  <div
    class="editable"
    (click)="edit()"
    (focus)="edit()"
    tabindex="0"
    [ngClass]="{ readonly: readonly }"
    [matTooltip]="value"
    [class.locked]="fieldDef.locked"
  >
    @if (isNestedField) {
      @for (item of value; track item.id; let last = $last) {
        <span [innerHTML]="item.label"></span>
        @if (!last) {
          <span>, </span>
        }
      }
    } @else {
      {{ value }}
    }
  </div>
} @else {
  <input
    #inputEditorControl
    type="text"
    class="my-1"
    tabindex="0"
    [maxLength]="10000"
    [disabled]="isDisabled"
    [(ngModel)]="value"
    (blur)="onBlur()"
    (keyup.enter)="onBlur()"
  />
  @if (value && value.length > 0) {
    <p class="mb-1 text-sm text-gray-500 text-right">Characters: {{ value.length }} / 10000</p>
  }
}
